import React from "react";

/**
 * HAL9000Eye - SVG HAL 9000 eye with pulsing glow, used on April 1st (Founders Day).
 */
const HAL9000Eye = ({ className = "" }) => (
  <svg className={`hal9000-eye${className ? " " + className : ""}`} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    {/* Outer housing — thin border matching navbar buttons */}
    <circle cx="50" cy="50" r="48" fill="#1a1a1a" stroke="var(--border-color)" strokeWidth="1.5" />
    {/* Bezel — chrome ring */}
    <circle cx="50" cy="50" r="44" fill="url(#hal-bezel-fill)" />
    {/* Dark lens cavity */}
    <circle cx="50" cy="50" r="37" fill="#060606" />
    {/* Concentric depth ring 1 */}
    <circle cx="50" cy="50" r="35" fill="none" stroke="#1a0000" strokeWidth="1.5" />
    {/* Concentric depth ring 2 */}
    <circle cx="50" cy="50" r="30" fill="none" stroke="#200000" strokeWidth="1" />
    {/* Outer red glow */}
    <circle cx="50" cy="50" r="34" fill="url(#hal-outer-glow)" />
    {/* Mid iris */}
    <circle cx="50" cy="50" r="23" fill="url(#hal-iris)" />
    {/* Inner bright core */}
    <circle cx="50" cy="50" r="9" fill="url(#hal-core)" />
    {/* Specular highlight — soft oval upper-left */}
    <ellipse cx="42" cy="40" rx="6" ry="4" fill="rgba(255,220,210,0.45)" transform="rotate(-25 42 40)" />
    {/* Pulsing glow overlay — animates via CSS */}
    <circle cx="50" cy="50" r="34" fill="url(#hal-pulse)" className="hal9000-pulse" />
    <style>{`
      @keyframes hal-pulse {
        0%, 100% { opacity: 0; }
        50%      { opacity: 1; }
      }
      .hal9000-pulse {
        animation: hal-pulse 3s ease-in-out infinite;
      }
    `}</style>
    <defs>
      {/* Bezel fill — off-center radial for polished chrome ring look */}
      <radialGradient id="hal-bezel-fill" cx="36%" cy="30%" r="70%">
        <stop offset="0%"   stopColor="#ffffff" />
        <stop offset="15%"  stopColor="#e8e8e8" />
        <stop offset="38%"  stopColor="#b0b0b0" />
        <stop offset="60%"  stopColor="#606060" />
        <stop offset="80%"  stopColor="#c0c0c0" />
        <stop offset="100%" stopColor="#707070" />
      </radialGradient>
      <radialGradient id="hal-outer-glow" cx="45%" cy="42%" r="55%">
        <stop offset="0%"   stopColor="#c01000" />
        <stop offset="50%"  stopColor="#7a0000" />
        <stop offset="100%" stopColor="#1e0000" />
      </radialGradient>
      <radialGradient id="hal-iris" cx="45%" cy="42%" r="55%">
        <stop offset="0%"   stopColor="#ee2200" />
        <stop offset="40%"  stopColor="#aa0000" />
        <stop offset="100%" stopColor="#3a0000" />
      </radialGradient>
      <radialGradient id="hal-core" cx="36%" cy="36%" r="65%">
        <stop offset="0%"   stopColor="#ffbbaa" />
        <stop offset="35%"  stopColor="#ff2200" />
        <stop offset="100%" stopColor="#990000" />
      </radialGradient>
      <radialGradient id="hal-pulse" cx="50%" cy="50%" r="50%">
        <stop offset="0%"   stopColor="#ff3300" stopOpacity="0.9" />
        <stop offset="60%"  stopColor="#ff1100" stopOpacity="0.4" />
        <stop offset="100%" stopColor="#ff0000" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export default HAL9000Eye;